import React from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { useYear } from "../context/YearContext";

const YearSelector = () => {
  const { years, selectedYear, changeYear, loading } = useYear();

  if (loading) return null;

  return (
    <Box sx={{ width: 240 }}>
      <Autocomplete
        options={years}
        value={selectedYear}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        onChange={(e, newValue) => {
          if (newValue) changeYear(newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} label="Select Year" size="small" />
        )}
      />
    </Box>
  );
};

export default YearSelector;






// // src/components/YearSelector.js
// import React from "react";
// import { Autocomplete, TextField, Box } from "@mui/material";
// import { useYear } from "../context/YearContext";

// const YearSelector = () => {
//   const { years, selectedYear, changeYear, loading } = useYear();

//   if (loading) return null;

//   return (
//     <Box sx={{ width: 240 }}>
//       <Autocomplete
//         options={years}
//         value={selectedYear}
//         getOptionLabel={(option) => option.name}
//         onChange={(event, newValue) => {
//           if (newValue) changeYear(newValue);
//         }}
//         isOptionEqualToValue={(option, value) => option.id === value.id}
//         renderInput={(params) => (
//           <TextField {...params} label="Select Year" size="small" />
//         )}
//       />
//     </Box>
//   );
// };

// export default YearSelector;